import React, { ReactElement } from 'react';
import TabTitle from './tabtitle';

import { useAppSelector } from '@hooks/statehooks';

import '@styles/tabs.scss';

interface TabsProps {
  children: ReactElement[];
  name: string;
}

const Tabs: React.FC<TabsProps> = ({ children, name }) => {
  const selectedTab = useAppSelector((state) => state.tabs);

  return (
    <>
      <ul className="tabs" role="tablist">
        {children.map((item, index) => (
          <TabTitle
            key={index}
            title={item.props.title}
            index={index}
            selectedTab={selectedTab[name]}
            name={name}
          />
        ))}
      </ul>
      {children[selectedTab[name]]}
    </>
  );
};

export default Tabs;
